import { createApi } from 'api/common/createApi'
import config, { API_TYPES } from 'constants/api-config'

// Clusters
export const mtApi = createApi({
  baseURL: config[API_TYPES.MT_API_URL],
})

export const copApi = createApi({
  baseURL: config[API_TYPES.PRACTITIONERS_API_URL],
})
